<div class="pt-2">
  <div *ngFor="let alert of alerts" class="{{cssClass(alert)}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close text-right" (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
